<app-header></app-header>

<main style="background: #ffffff">
  <router-outlet></router-outlet>
</main>

<app-citizen-home-footer></app-citizen-home-footer>
